import {
  allOptionsInterface,
  allOptionsInterfaceBultEdit,
  NDCBulkEditFormFields,
  NDCBulkEditFormFieldsTypes,
  NDCEditFormDropDownResponseInterface,
  NDCFormFields,
  NDCFormFieldsTypes,
  NDCInformationInterface,
  targetMarketShareInstanceInterface,
} from 'Interfaces/FactsInterfaces/drugInterfaces';
import { formatDate, getFirstDayOfMonth } from 'utils/dateUtilities';
import { deepCopy } from 'utils/deepCopy';

export const createNdcPopUpDataForIndividualEdit = (
  ndcRowData: NDCInformationInterface,
  selected: boolean = false,
  emptyValue: boolean = false
) => {
  const data: NDCFormFields = {
    PPS: {
      fieldName: 'PPS',
      selected: selected,
      value: emptyValue ? '' : ndcRowData.PPS,
      startDate: emptyValue ? '' : ndcRowData.PPSStartDate,
      endDate: emptyValue ? '' : ndcRowData.PPSEndDate,
      datesDisabled: false,
      typeChangeDisabled: false,
      monthYearDates: false,
    },
    PPSSC: {
      fieldName: 'PPS Reason',
      selected: selected,
      value: emptyValue ? '' : ndcRowData.PPSReason,
      startDate: emptyValue ? '' : ndcRowData.PPSStartDate,
      endDate: emptyValue ? '' : ndcRowData.PPSEndDate,
      datesDisabled: false,
      typeChangeDisabled: false,
      monthYearDates: false,
    },
    Segmentation: {
      fieldName: 'Financial Segmentation',
      selected: selected,
      value: emptyValue ? '' : ndcRowData.Segmentation,
      startDate: emptyValue ? '' : ndcRowData.SegmentationStartDate,
      endDate: emptyValue ? '' : ndcRowData.SegmentationEndDate,
      datesDisabled: false,
      typeChangeDisabled: false,
      monthYearDates: true,
    },
    DPStrategy: {
      fieldName: 'Demand Planning',
      selected: selected,
      value: emptyValue ? '' : ndcRowData.DPstratergy,
      startDate: emptyValue ? '' : ndcRowData.DPSStartDate,
      endDate: emptyValue ? '' : ndcRowData.DPSEndDate,
      datesDisabled: false,
      typeChangeDisabled: false,
      monthYearDates: true,
    },
  };
  return data;
};

export const createNdcPopUpDataForBulkEdit = () => {
  // const date = new Date();
  const data: NDCBulkEditFormFields = {
    PPS: {
      fieldName: 'PPS',
      selected: false,
      value: '',
      startDate: '',
      endDate: '',
      datesDisabled: false,
      typeChangeDisabled: false,
      monthYearDates: false,
    },
    PPSSC: {
      fieldName: 'PPS Reason',
      selected: false,
      value: '',
      startDate: '',
      endDate: '',
      datesDisabled: true,
      typeChangeDisabled: true,
      monthYearDates: false,
    },
    Segmentation: {
      fieldName: 'Financial Segmentation',
      selected: false,
      value: '',
      startDate: '',
      endDate: '',
      datesDisabled: false,
      typeChangeDisabled: false,
      monthYearDates: true,
    },
    DPStrategy: {
      fieldName: 'Demand Planning',
      selected: false,
      value: '',
      startDate: '',
      endDate: '',
      datesDisabled: false,
      typeChangeDisabled: false,
      monthYearDates: true,
    },
  };
  return data;
};

// this functions conversts the date in dp strategy and segmentation to the month and  year format, which comes from backend in normal date format
// and this is being used to modify the initial assignment to ndc individual edit prefilled date
export const modifyNdcPopUpDateForIndividualEdit = (ndcRowData: NDCInformationInterface) => {
  const tempNdcRowDate = deepCopy(ndcRowData);

  if (tempNdcRowDate.SegmentationStartDate) {
    tempNdcRowDate.SegmentationStartDate = formatDate(
      getFirstDayOfMonth(tempNdcRowDate.SegmentationStartDate).toDateString()
    );
  }
  if (tempNdcRowDate.DPSStartDate) {
    tempNdcRowDate.DPSStartDate = formatDate(
      getFirstDayOfMonth(tempNdcRowDate.DPSStartDate).toDateString()
    );
  }
  if (tempNdcRowDate.SegmentationEndDate) {
    tempNdcRowDate.SegmentationEndDate = formatDate(
      getFirstDayOfMonth(tempNdcRowDate.SegmentationEndDate).toDateString()
    );
  }
  if (tempNdcRowDate.DPSEndDate) {
    tempNdcRowDate.DPSEndDate = formatDate(
      getFirstDayOfMonth(tempNdcRowDate.DPSEndDate).toDateString()
    );
  }
  return tempNdcRowDate;
};

export const createEmptyFieldObject = (fieldName: NDCBulkEditFormFieldsTypes) => {
  const tempData = createNdcPopUpDataForBulkEdit();
  tempData[fieldName].selected = false;
  return tempData[fieldName];
};

export const convertNdcFormDataToAllOptions = (
  dropDownData: NDCEditFormDropDownResponseInterface
) => {
  const allOptions: allOptionsInterface = { PPS: [], PPSSC: [], Segmentation: [], DPStrategy: [] };

  dropDownData.PPSDescriptions.forEach(description => {
    allOptions.PPS.push({
      code: description.PricingStrategyDescription,
      name: description.PricingStrategyDescription,
    });
  });
  dropDownData.DpStrategies.forEach(description => {
    allOptions.DPStrategy.push({
      code: description.ReportingSegmentName,
      name: description.ReportingSegmentName,
    });
  });
  dropDownData.PPSReasons.forEach(description => {
    allOptions.PPSSC.push({ code: description.Reason, name: description.Reason });
  });
  dropDownData.ReportingSegments.forEach(description => {
    allOptions.Segmentation.push({
      code: description.ReportingSegmentName,
      name: description.ReportingSegmentName,
    });
  });

  return allOptions;
};

export const selectedOptionUtility = (
  allOptions: allOptionsInterface | null,
  type: NDCFormFieldsTypes,
  value: string
) => {
  let option = { code: '', name: '' };
  if (allOptions)
    allOptions[type].forEach(currOption => {
      if (currOption.code === value) {
        option = currOption;
      }
    });
  return option;
};

export const convertNdcFormDataToAllOptionsBultEdit = (
  dropDownData: NDCEditFormDropDownResponseInterface
) => {
  const allOptions: allOptionsInterfaceBultEdit = {
    PPS: [],
    PPSSC: [],
    Segmentation: [],
    DPStrategy: [],
  };

  dropDownData.PPSDescriptions.forEach(description => {
    allOptions.PPS.push({
      code: description.PricingStrategyDescription,
      name: description.PricingStrategyDescription,
    });
  });
  dropDownData.DpStrategies.forEach(description => {
    allOptions.DPStrategy.push({
      code: description.ReportingSegmentName,
      name: description.ReportingSegmentName,
    });
  });
  dropDownData.PPSReasons.forEach(description => {
    allOptions.PPSSC.push({ code: description.Reason, name: description.Reason });
  });
  dropDownData.ReportingSegments.forEach(description => {
    allOptions.Segmentation.push({
      code: description.ReportingSegmentName,
      name: description.ReportingSegmentName,
    });
  });

  return allOptions;
};

export const selectedOptionUtilityBultEdit = (
  allOptions: allOptionsInterfaceBultEdit | null,
  type: NDCBulkEditFormFieldsTypes,
  value: string
) => {
  let option = { code: '', name: '' };
  if (allOptions)
    allOptions[type].forEach(currOption => {
      if (currOption.code === value) {
        option = currOption;
      }
    });
  return option;
};

export const createEmptyDataForIndireTargetMarketShare = (marketShareId: number | null = null) => {
  const data: targetMarketShareInstanceInterface = {
    MarketShareID: marketShareId,
    GFC: 0,
    COT: '',
    TargetMarketShare: '',
    TMSStrategyID: {
      TMSStrategyCode: '',
      TMSDescription: '',
      Active: true,
    },
    SellingCategory: '',
    StartDate: '',
    EndDate: '',
    IsActive: true,
  };
  return data;
};
